<template>
  <v-container
    class="fill-height"
    fluid
    grey darken-4
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        sm="12"
        md="10"
      >
        <v-img
          :src="require('@/assets/rescue.png')"
          contain
          aspect-ratio="4"
        />
      </v-col>
      <v-col
        cols="12"
        md="10"
      >
        <blockquote class="blockquote white--text text-justify">
“Animales al rescate – Episodio 1” es un videojuego tipo Plataforma de 8 niveles, orientado a
niños de entre 8 y 10 años. Como parte de la jugabilidad, tendrá que resolver 8 evaluaciones de
20 multiplicaciones cada una, de los tipos 1x1, 2x1, 3x1, 4x1 y 2x2 dígitos además de por
múltiplos de 10. Así mismo, a través de la historia del juego, se le explicarán los conceptos
básicos sobre la deforestación de la selva amazónica como problemática medioambiental.
Específicamente, lo relacionado a las causas, consecuencias, causantes, alcance, estado actual y
propuestas de solución.
<br><br>A través de la plataforma Web, tanto el niño como el padre y/o profesor podrán acceder a los
resultados de las evaluaciones. Aún si no termina de pasar un nivel, se estima que en una sesión
de aproximadamente 40 minutos habrá concluido con la resolución de la evaluación respectiva,
teniendo la posibilidad de finalizarlo en cualquier otro momento. Así mismo, dado que la
propuesta está diseñada para también funcionar como herramienta de evaluación periódica, en
un contexto escolar de aprendizaje sobre los tipos de multiplicaciones indicados, es posible
gestionar grupos de alumnos y visualizar comparativos de sus rendimientos individuales.
<br><br>También se medirán los tiempos de resolución por multiplicación y lectura de los textos con los
que se cuenta la historia del juego. Esta última variable contribuye con la evaluación de
comprensión lectora que podría realizarse a partir de lo que el niño leerá en la narrativa. En ese
sentido, otra actividad recomendada es que el juego sirva como punto de partida para trabajar
aprendizaje basado en proyectos. Dado que para el niño será prácticamente como jugar un
videojuego tradicional del tipo Plataforma, su uso le resultará entretenido, generándole interés
y provocándole curiosidad. A partir de esta motivación, se crea un contexto favorable para que
se trabajen proyectos de aprendizaje relacionados a, por ejemplo, los conceptos ambientales
que se le explican en la historia.
<br><br>Especificaciones adicionales:
<br>•	Juego y Plataforma disponibles para computadoras de escritorio y/o laptops.
<br>•	Padres, profesores y alumnos pueden ingresar a la plataforma en esta web, a través
del ícono que se muestra en la parte superior, junto a los de nuestras redes sociales.
<br>•	Padres y profesores se pueden registrar a través del ícono de ingreso a la plataforma. Al
concluir dicho proceso, <b><u>pueden probar de forma gratuita el primer nivel del juego y
visualizar su reporte de desempeño.</u></b>
<br>•	El profesor podrá ver la información de los niños cuyos padres hayan adquirido la
licencia respectiva, o de los que él autorice al comprar las propias.
<br>•	Padres y profesores pueden comprar licencias individuales a través de la plataforma. El
precio de cada licencia es de US$ 8.5. Las compras serán procesadas de forma segura a
través de Niubiz, empresa líder en el mercado peruano de procesamiento de pagos y
operaciones financieras.
<br>•	Si eres un alumno, alguno de tus padres o profesor te debe enviar una invitación para
que puedas registrarte.
<br>•	Descarga el juego y comienza a jugar con el correo y contraseña establecidos en el
registro.
<br>• Si al presionar “DESCARGA” no ocurre nada, es probable que tu navegador esté
bloqueando la ventana de descarga respectiva.
<br>• Durante el registro de usuarios y uso de algunas funciones de la plataforma, se enviarán
correos electrónicos a las direcciones registradas. En caso de que estos no se visualicen
en la bandeja de entrada, es probable que hayan ingresado a la de “Correos no
deseados”.
</blockquote>
      </v-col>
      <v-col
        cols="12"
        md="10"
        class="text-center"
      >
        <v-btn
          class="primary"
          @click="downloadOpen(`windows`)"
        >
          DESCARGA
          <v-icon
            dark
            right
          >
            mdi-microsoft-windows
          </v-icon>
        </v-btn>
        <v-btn
          class="primary"
          @click="downloadOpen(`macosx`)"
        >
          DESCARGA
          <v-icon
            dark
            right
          >
            mdi-apple
          </v-icon>
        </v-btn>
      </v-col>
            <v-col
        cols="12"
        sm="4"
        class="text-center"
      >
        <!-- <v-btn
          class="warning"
          :disabled="user !== null"
          @click="loginDialog = !loginDialog"
        >
          INGRESAR
        </v-btn> -->
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      max-width="480"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2 text-left">
          DESCARGA<v-icon
            color="primary"
            large
            right
          >
            {{ icon }}
          </v-icon>
        </v-card-title>

        <v-subheader class="mt-4">
          Requisitos minimos de sistema para jugar ANIMALES AL RESCATE.
        </v-subheader>

        <v-card-text v-if="type === 'windows'">
          OS: Windows 8 / 10
          <br>Procesador: Intel Core 2 Duo 2.8GHz / AMD 2400
          <br>Memoria: 1.5GB RAM 
          <br>Gráficos: 128 MB compatible con DirectX 9
          <br>Almacenamiento: 500 MB
        </v-card-text>

        <v-card-text v-else>
          <br>OS: MacOSX 10.9+
          <br>Procesador: 2.0 GHz Dual Core o mayor
          <br>Memoria: 2 GB RAM
          <br>Gráficos: 1 GB VRAM de GPU integrado o mejor
          <br>Almacenamiento: 500 MB
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="download"
          >
            Descargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <login
      :login-dialog="loginDialog"
      @updateLoginDialog="updateLoginDialog"
    />
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import login from '@/views/dashboard/pages/auth/Login'

  export default {
    components: {
      login,
    },
    data () {
      return {
        loginDialog: false,
        dialog: false,
        icon: '',
        type: 'windows',
        buildDownloadUrl:
          'https://us-central1-videojuego-sh.cloudfunctions.net/buildDownloadUrl',
        windowsURL:'https://storage.googleapis.com/videojuego-sh.appspot.com/Builds/AnimalesAlRescate(windows).exe',
        macosxURL:'https://storage.googleapis.com/videojuego-sh.appspot.com/Builds/AnimalesAlRescate(macosx).zip',
      }
    },
    computed: {
      ...mapState(['user']),
    },
    methods: {

      downloadOpen (type) {
        this.type = type
        this.icon = type === 'windows' ? 'mdi-microsoft-windows' : 'mdi-apple'
        this.dialog = true
      },
      download () {

        switch (this.type)
        {
          case `windows`:
            window.open(this.windowsURL)
            break;
          case `macosx`:  
            window.open(this.macosxURL)
            break;
        }

        // axios
        //   .post(this.buildDownloadUrl, {
        //     type: this.type,
        //   })
        //   .then(response => {
        //     const data = response.data
        //     const error = data.error
        //     if (!error) {
        //       const message = data.message
        //       const downloadUrl = data.downloadUrl
        //       console.log(message)
        //       window.open(downloadUrl)
        //     }
        //   })
        //   .catch(error => {
        //     console.log(error)
        //     alert(error)
        //   })
      },
      updateLoginDialog (newData) {
        this.loginDialog = newData
      },
    },
  }
</script>
